<template lang='pug'>
  div(:class='$style[`cc-question-panel`]')
    div(:class='$style[`cc-question-panel-status`]')
      //- 文章下方推薦數
      div(
        v-if='totalAgree < 1 && agreeToggle'
        :title='`你已經推薦`'
        :class='[$style[`cc-status-agree`], $style[`cc-status-ui`]]'
        @click='handleShowAgreeList(qid)')
        i.toggle-icon.toggle-icon-agree(:class='$style[`ic-agree`]')
        span.font-medium {{ `你已推`}}
        div(:class='$style[`cc-status-agree-showTip`]')
          span!= '醫師推薦者'

      div(
        v-else-if='totalAgree >= 1 && !agreeToggle'
        :title='`${totalAgree}位醫師推薦`'
        :class='[$style[`cc-status-agree`], $style[`cc-status-ui`]]'
        @click='handleShowAgreeList(qid)')
        i.toggle-icon.toggle-icon-agree(:class='$style[`ic-agree`]')
        span.font-medium {{ `${totalAgree}推` }}
        div(:class='$style[`cc-status-agree-showTip`]')
          span!= '醫師推薦者'

      div(
        v-else-if='totalAgree >= 1 && agreeToggle'
        :title='`你和${totalAgree}位醫師推薦`'
        :class='[$style[`cc-status-agree`], $style[`cc-status-ui`]]'
        @click='handleShowAgreeList(qid)')
        i.toggle-icon.toggle-icon-agree(:class='$style[`ic-agree`]')
        span.font-medium {{ `你和${totalAgree}` }}
        div(:class='$style[`cc-status-agree-showTip`]')
          span!= '醫師推薦者'

      //- 文章下方讚數
      div(
        v-if='totalLike < 1 && likeToggle'
        :title='`你已經給讚`'
        :class='[$style[`cc-status-like`], $style[`cc-status-ui`]]')
        i.toggle-icon.toggle-icon-like(:class='$style[`ic-like`]')
        span.font-medium {{ `你已讚` }}
      div(
        v-else-if='totalLike >= 1 && !likeToggle'
        :title='`${totalLike}人給讚`'
        :class='[$style[`cc-status-like`], $style[`cc-status-ui`]]')
        i.toggle-icon.toggle-icon-like(:class='$style[`ic-like`]')
        span.font-medium {{ `${totalLike}讚` }}
      div(
        v-else-if='totalLike >= 1 && likeToggle'
        :title='`你和${totalLike}人給讚`'
        :class='[$style[`cc-status-like`], $style[`cc-status-ui`]]')
        i.toggle-icon.toggle-icon-like(:class='$style[`ic-like`]')
        span.font-medium {{ `你和${totalLike}` }}

      div(
        v-if='totalAgree <= 0 && totalLike <= 0 && !agreeToggle && !likeToggle'
        :title='`尚無推薦或讚數`'
        :class='[$style[`cc-status-ui`], $style[`cc-status-no-data`]]')
        span.font-medium {{ `尚無推薦或讚數` }}
        //- span(v-html='likeBtnActive ? `你和${dataBrief.status.like}人` : dataBrief.status.like')

      //- div(
      //-   :title='`回覆數`'
      //-   :class='[$style[`cc-status-reply`], $style[`cc-status-ui`]]')
      //-   IconDialog(:size='20' :color='`#b1b1b1`')
        //- span.font-medium {{ `20回覆` }}

</template>

<script>
import { mapMutations } from 'vuex';
// import IconDialog from '../../icon/Dialog';
export default {
  // components: {
  //   IconDialog,
  // },

  props: {
    qid: {
      type: Number,
      default: null,
    },
    totalAgree: {
      type: Number,
      default: 40,
    },
    totalLike: {
      type: Number,
      default: 22,
    },
  },

  data() {
    return {
      agreeToggle: false,
      likeToggle: false,
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopAgreeListStatus: 'global/POPAGREE_LIST_STATUS',
    }),

    handleShowAgreeList(dataId) {
      this.changePopAgreeListStatus({
        active: true,
        type: 'qa',
        id: `${dataId}`,
      });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //     loginStatus: 'user/exportLoginStatus',
  //     loginProfile: 'user/exportUserProfile',
  //     loginDjangoId: 'user/exportUserDjangoId',
  //     authJwtToken: 'user/exportUserJwtToken',
  //   }),
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/qa/questionPanel.scss';
</style>
